export default {
  tab: {
    _3_months: '3M',
    _6_months: '6M',
    _9_months: '9M',
    this_year: '1Y',
    year_to_date: 'YTD',
  },
  valueProprotion: 'Value Proportion (%)',
  tooltip: {
    fmiAbs: 'FMI Abs',
    fmiRel: 'FMI Rel',
  },
  fmi: 'FMI 5',
  closeIndex: 'Close Index',
  rightLabelAbs: `FMI (Abs) - Billion VND`,
  rightLabelRel: `FMI (Rel) - Billion VND`,
  chartTitleAbsolute: 'FIINTRADE MONEY FLOW INDEX ABSOLUTE (FMI ABS)',
  chartTitleRelative: 'FIINTRADE MONEY FLOW INDEX RELATIVE (FMI REL)',
  legendFmiAbs: 'FMI Abs',
  legendFmiRel: 'FMI Rel',
  footer: `For detailed FMI tutorial 
  <a target="_blank" rel="noreferrer noopener" href="%{url}">click here</a> 
  (Data will be updated at the end of the day)
 `,
};
